import React, { useState, useEffect } from 'react';
import Input from '../../components/shared/input';
import SearchIcon from '../../assets/icons/search-icon.svg';
import OKIcon from '../../assets/icons/ok.svg';
import WarningIcon from '../../assets/icons/warning.svg';
import ErrorIcon from '../../assets/icons/error.svg';
import SidePanel from '../../components/shared/side-panel';
import DefaultLogo from '../../assets/dummy/cards/puzzle.png';
import PopularIntegrations from './sections/popular-integrations';
import SkeletonCard from '../../components/shared/skeleton-card';
import queryString from 'query-string';
import Pagination from '../../components/shared/pagination';
import EmptyResults from './sections/empty-results';
// import ResultSummary from './sections/result-summary';
import Icon from '../../components/shared/icon';
import HomeFeedCard from './sections/home-feed-card';

import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { ElsaPurchaseStatus } from '../../models/elsa-models';

function Home({ location, history }) {

  const [timeout, setTime] = useState(0);

  const { t: trans } = useTranslation();

  const qString = queryString.parse(location.search);

  const products = useSelector(state => state.products);

  const { addToast } = useToasts();

  useEffect(() => {
    if (!products.pending && products.error) {
      addToast(<div className='app-toast'>
        <p> {trans('common-action.server-error')}</p>
        <p>{trans('common-action.try-agian')}</p> </div>,
        {
          appearance: 'error', autoDismiss: true
        })
    }
  }, [addToast, products.error, products.pending, trans]);

  /**
   * filter data according to 
   * user preferences (search, filters and etc).
   */
  const filterData = () => {
    if (!products.pending) {

      let prods = products.data;
      if (Object.entries(qString).length !== 0) {
        // filter by searched text
        if (qString.search && qString.search !== 'undefined') {
          prods = products.data.filter(item => {
            return (item.name || '').toLowerCase().includes(qString.search.toLowerCase()) ||
              (item.label || '').toLowerCase().includes(qString.search.toLowerCase()) ||
              (item.description || '').toLowerCase().includes(qString.search.toLowerCase()) ||
              (item.vendor || '').toLowerCase().includes(qString.search.toLowerCase()) ||
              (item.categoryName || '').toLowerCase().includes(qString.search.toLowerCase())
          });
        }
        
        // filter by product type
        if (Object.keys(qString)?.includes('productTypes') && qString?.productTypes !== 'undefined') {
           prods = prods.filter(product => qString.productTypes?.toString().includes(product.productType));
        }

        // filter by category
        if (qString.category && qString.category !== 'undefined' && qString.category !== 'all') {
          prods = prods.filter(item => (item.categoryName || '').toLowerCase() === qString.category)
        }
        
      }
      return prods;
    }
  }

  // splitting into chunks. Each chunk contains maximum upto 9 records 
  const setPagination = (products) => {
    if (products && products.length > 9) {
      return products.reduce((prods, item, index) => {
        const chunkIndex = Math.floor(index / 9)
        if (!prods[chunkIndex]) {
          prods[chunkIndex] = []
        }
        prods[chunkIndex].push(item)
        return prods;
      }, [])
    } else {
      if (products && products.length) {
        const prods = []
        prods.push(products);
        return prods;
      }
    }
  }

  const data = filterData();

  const filteredProducts = setPagination(data);

  // const getNumberOfRecords = () => {
  //   let num = 0;
  //   if (filteredProducts && Object.entries(filteredProducts).length !== 0)
  //     filteredProducts.forEach(page => {
  //       num += page.length;
  //     });
  //   return num;
  // }

  const handleNavigation = (id) => {
    history.push(`/integration/${id}`);
  }

  /**
   * handle input change with a delay
   */
  const handleSearch = (e) => {
    let search = e.target.value;
    let category = (qString.category || 'all');
    let productTypes = (qString.productTypes || '');
    if (timeout) clearTimeout(timeout);
    setTime(setTimeout(() => {
      history.push(`/?page=&category=${category}&search=${search}&productTypes=${productTypes}`);
    }, 300))
  }

  const handlePagination = (page) => {
    let search = (qString.search || '');
    let category = (qString.category || 'all');
    let productTypes = (qString.productTypes || '');
    history.push(`/?page=${page}&category=${category}&search=${search}&productTypes=${productTypes}`);
  }

  const getStatusText = (product) => {
    switch (product?._purchaseStatus) {
      case ElsaPurchaseStatus.Accepted:
        return <span className='active'><Icon icon={OKIcon} classes="xs" />{trans('detail.activated')}</span>
      case ElsaPurchaseStatus.Rejected:
        return <span className='rejected'><Icon icon={ErrorIcon} classes="xs" /> {trans('detail.rejected')}</span>
      case ElsaPurchaseStatus.Pending:
        return <span className='pending'><Icon icon={WarningIcon} classes="xs" /> {trans('detail.pending')}</span>
      default:
        if (product.price === 0) return '';
        return `${product.price}kr ${trans('result.per-company')}`
    }
  }

  return (
    <div className="page-wrapper">
      <div className="home-page">
        <Container className="home-container">

          <Row className="main-content">
            <Col lg={2}>
              <SidePanel />
            </Col>
            <Col lg={10}>
              <Row>
                <Col className='home-search-block'>
                  <Input icon={SearchIcon} type="text" onChange={handleSearch} placeHolder={trans('search.search-input')} />
                </Col>
              </Row>
              {/* {
                !products.pending &&
                <Row>
                  <ResultSummary classes='summary'
                    numOfResults={getNumberOfRecords()}
                    searchedText={qString.search}
                    category={qString.category}
                  />
                </Row>
              } */}

              <Row className="cards-container">
                {products.pending &&
                  <>
                    {/* <section className='skeleton-summary skeleton-box'>
                      <span></span>
                      <span></span>
                      <span></span>
                    </section> */}
                    {
                      [...Array(9)].map((_, index) =>
                        <Col lg={4} key={index} className="card-wrapper">
                          <SkeletonCard />
                        </Col>
                      )
                    }
                  </>
                }
                {!products.pending &&
                  filteredProducts &&
                  Object.entries(filteredProducts).length !== 0 ?
                  filteredProducts[qString.page ? qString.page - 1 : 0].map((product, index) => {
                    return <Col lg={4} className="card-wrapper" key={index}>
                      <HomeFeedCard
                        iconReference={product.iconReference}
                        title={product.label}
                        vender={`${product.vendor ? `${trans('result.by')} ${product.vendor}` : ''}`}
                        category={product.categoryName}
                        description={product.description}
                        transactionText={getStatusText(product)}
                        buttonText={trans('result.more')}
                        onClick={handleNavigation.bind(null, product.id)}
                      />
                    </Col>

                  }) : !products.pending && <EmptyResults />}
              </Row>

              <div className="paginaiton-block">
                {filteredProducts &&
                  Object.entries(filteredProducts).length !== 0 &&
                  <Pagination currentPage={qString.page} pages={filteredProducts} onClick={handlePagination} />
                }
              </div>

            </Col>
          </Row>
        </Container>
        <div className="secondary-content">
          <Container>
            <PopularIntegrations icon={DefaultLogo} />
          </Container>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Home);